// format a value
export function formatValue(value, format, fractionDigits = 0) {
  switch (format) {
    case 'count':
      if (value % 1 === 0) {return value;}
      break;
    case 'currency':
      return value.toLocaleString('nl-NL', {style: 'currency', currency: 'EUR', minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits});
      break;
    default:
      return value;
  }
}
